import { BILLING_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Billing/config";
import { ERROR_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Error/config";
import { FILTER_ALERT_COMPONENT_TRANSLATION_NAMESPACE } from "src/components/Filters/FilterAlert/config";
import { FILTERS_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Filters/config";
import { MARKETING_ACTION_FEEDBACK_BANNER_COMPONENTS_NAMESPACE } from "src/components/MarketingActionFeedbackBanner/config";
import { MARKETING_ACTION_TABLE_COMPONENTS_NAMESPACE } from "src/components/MarketingActionTable/config";
import { OFFER_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/Offer/config";
import { SPONSORED_AD_COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/SponsoredAd/config";
import { TABLE_TRANSLATION_NAMESPACE } from "src/components/Table2/config";
import { COMPONENTS_TRANSLATION_NAMESPACE } from "src/components/config";
import { ERROR_SF_TRANSLATION_NAMESPACE } from "src/components/sf-degraded-mode/config";
import { DESIGN_SYSTEM_TRANSLATION_NAMESPACE } from "src/design-system/core";
import { NOTIFICATIONS_TRANSLATION_NAMESPACE } from "src/layouts/SharedLayout/TopBar/notifications/config";
import { SHARED_LAYOUT_NAMESPACE } from "src/layouts/SharedLayout/config";
import { FORMATTERS_TRANSLATION_NAMESPACE } from "src/utils/formatters";
import { DASHBOARD_TRANSLATION_NAMESPACE } from "src/views-ds/dashboard/config";
import { WELCOME_PAGE_VIEW_TRANSLATION_NAMESPACE } from "src/views-ds/welcome/config";
import { ACCOUNT_TRANSLATION_NAMESPACE } from "src/views/account/config";
import { ADMIN_MONITORING_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/admin-monitoring/config";
import { ADMIN_SUPERPOWER_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/admin-superpower/config";
import { ADMIN_DASHBOARD_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/dashboard/config";
import { ADMIN_EXPORT_LIST_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/export-list-view/config";
import { MONITORING_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/monitoring/config";
import { STRIPE_NAMESPACE } from "src/views/admin/AdminView/non-reg/components/config";
import { NEWSLETTER_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/non-reg/config";
import { ADMIN_OPERATION_SPECIAL_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/operation-special-view/config";
import { ADMIN_PLATFORM_POS_LIST_TRANSLATION_NAMESPACE } from "src/views/admin/AdminView/platform-pos-list-view/config";
import { ADMIN_TRANSLATION_NAMESPACE } from "src/views/admin/config";
import { AGENDA_TRANSLATION_NAMESPACE } from "src/views/agenda/config";
import { AUTH_TRANSLATION_NAMESPACE } from "src/views/auth/config";
import { VIEWS_COMPONENTS_TRANSLATION_NAMESPACE } from "src/views/components/config";
import { ERRORS_TRANSLATION_NAMESPACE } from "src/views/errors/config";
import { MARKETING_ACTION_SELECTOR_TRANSLATION_NAMESPACE } from "src/views/marketing-actions/components/MarketingActionSelector/config";
import { SWAP_OFFER_TYPE_BUTTON_TRANSLATION_NAMESPACE } from "src/views/marketing-actions/components/SwapOfferTypeButton/config";
import { MARKETING_ACTIONS_TRANSLATION_NAMESPACE } from "src/views/marketing-actions/config";
import { OFFER_TRANSLATION_NAMESPACE } from "src/views/offer/config";
import { ONBOARDING_TRANSLATION_NAMESPACE } from "src/views/onboarding/config";
import { ORGANIZATION_TRANSLATION_NAMESPACE } from "src/views/organization/config";
import { POS_TRANSLATION_NAMESPACE } from "src/views/pos/config";
import { VISIBILITY_TRANSLATION_NAMESPACE } from "src/views/ranking/config";
import { SPONSORED_AD_TRANSLATION_NAMESPACE } from "src/views/sponsored-ads/config";

export const COMMON_TRANSLATION_NAMESPACE = "common";
export const COUNTRIES_TRANSLATION_NAMESPACE = "countries";
export const OLD_TRANSLATION_NAMESPACE = "old_translations";

export const TRANSLATION_ALL_NAMESPACE = [
    COMMON_TRANSLATION_NAMESPACE,
    COUNTRIES_TRANSLATION_NAMESPACE,
    COMPONENTS_TRANSLATION_NAMESPACE,
    BILLING_COMPONENTS_TRANSLATION_NAMESPACE,
    ERROR_COMPONENTS_TRANSLATION_NAMESPACE,
    FILTERS_COMPONENTS_TRANSLATION_NAMESPACE,
    FILTER_ALERT_COMPONENT_TRANSLATION_NAMESPACE,
    OFFER_COMPONENTS_TRANSLATION_NAMESPACE,
    SPONSORED_AD_COMPONENTS_TRANSLATION_NAMESPACE,
    MARKETING_ACTION_FEEDBACK_BANNER_COMPONENTS_NAMESPACE,
    MARKETING_ACTION_TABLE_COMPONENTS_NAMESPACE,
    TABLE_TRANSLATION_NAMESPACE,
    ACCOUNT_TRANSLATION_NAMESPACE,
    ADMIN_TRANSLATION_NAMESPACE,
    AGENDA_TRANSLATION_NAMESPACE,
    AUTH_TRANSLATION_NAMESPACE,
    DASHBOARD_TRANSLATION_NAMESPACE,
    WELCOME_PAGE_VIEW_TRANSLATION_NAMESPACE,
    ERRORS_TRANSLATION_NAMESPACE,
    ERROR_SF_TRANSLATION_NAMESPACE,
    OFFER_TRANSLATION_NAMESPACE,
    ONBOARDING_TRANSLATION_NAMESPACE,
    ORGANIZATION_TRANSLATION_NAMESPACE,
    POS_TRANSLATION_NAMESPACE,
    SPONSORED_AD_TRANSLATION_NAMESPACE,
    VISIBILITY_TRANSLATION_NAMESPACE,
    VIEWS_COMPONENTS_TRANSLATION_NAMESPACE,
    MARKETING_ACTION_SELECTOR_TRANSLATION_NAMESPACE,
    SWAP_OFFER_TYPE_BUTTON_TRANSLATION_NAMESPACE,
    FORMATTERS_TRANSLATION_NAMESPACE,
    MONITORING_TRANSLATION_NAMESPACE,
    ADMIN_DASHBOARD_TRANSLATION_NAMESPACE,
    NOTIFICATIONS_TRANSLATION_NAMESPACE,
    NEWSLETTER_TRANSLATION_NAMESPACE,
    ADMIN_OPERATION_SPECIAL_TRANSLATION_NAMESPACE,
    ADMIN_PLATFORM_POS_LIST_TRANSLATION_NAMESPACE,
    MARKETING_ACTIONS_TRANSLATION_NAMESPACE,
    ADMIN_MONITORING_TRANSLATION_NAMESPACE,
    ADMIN_SUPERPOWER_TRANSLATION_NAMESPACE,
    SHARED_LAYOUT_NAMESPACE,
    DESIGN_SYSTEM_TRANSLATION_NAMESPACE,
    ADMIN_EXPORT_LIST_TRANSLATION_NAMESPACE,
    STRIPE_NAMESPACE,
];
